<script>
import HandlesActions from '../mixins/Overview/HandlesActions';

export default {
    mixins: [HandlesActions],

    props: {
        url: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            default: 'default',
        },
    },

    render() {
        return null;
    },

    async mounted() {
        this.openModal(this.url, this.size).then(result => this.$emit('closed', result));
    },
};
</script>
